<template>
  <div class="social-share-wrapper">
    <div
      class="d-inline-flex flex-wrap align-items-center justify-content-start gap-2 border border-light shadow-sm p-2 rounded"
    >
      <a
        href="https://www.facebook.com/mediusware"
        target="_blank"
        rel="noopener noreferrer"
        class="social-icon"
      >
        <img src="/assets/icon/facebook-f-brands.svg" alt="Facebook" />
      </a>

      <a
        href="https://www.linkedin.com/company/mediusware-ltd"
        target="_blank"
        rel="noopener noreferrer"
        class="social-icon"
      >
        <img src="/assets/icon/linkedin-in-brands.svg" alt="LinkedIn" />
      </a>

      <a
        href="https://twitter.com/MediuswareLtd"
        target="_blank"
        rel="noopener noreferrer"
        class="social-icon"
      >
        <img src="/assets/icon/twitter-brands.svg" alt="Twitter" />
      </a>
      <!-- Copy Link Button -->
      <button
        class="social-icon copy-btn"
        type="button"
        @click="copyPageLink"
        title="Copy Page Link"
      >
          <i class="fas fa-link"></i>
      </button>
    </div>

    <!-- Toast Message -->
    <div v-if="copied" class="copy-toast">Link copied!</div>
  </div>
</template>

<script>
export default {
  name: "SocialShareCopy",
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    copyPageLink() {
      const currentUrl = window.location.href;
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
          this.copied = true;
          setTimeout(() => (this.copied = false), 2000);
        })
        .catch((err) => console.error("Failed to copy:", err));
    },
  },
};
</script>

<style scoped>
.social-share-wrapper {
  position: relative;
}

.social-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #091e42;
  border: 1px solid #e1e1e1;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-icon img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.social-icon:hover {
  background-color: #0060af;
  transform: scale(1.08);
}

.social-icon:hover img {
  filter: brightness(0) invert(1);
}

.copy-btn {
  color: #0060af;
  font-size: 16px;
  background-color: white;
}

.copy-btn:hover {
  color: white;
}

.copy-toast {
  position: absolute;
  bottom: -35px;
  left: 0;
  background-color: #0060af;
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 6px;
  animation: fadeInOut 2s ease forwards;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  20% {
    opacity: 1;
    transform: translateY(0);
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(10px);
  }
}
</style>
